module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-debate_gray.284124f0.svg";